import Api, { configFormData } from "@/config/Api";

export default {
  getWithholdings(options = {}) {
    return Api().get(`/withholdings`, options);
  },
  getWithholdingId(withholdingId) {
    return Api().get(`/withholdings/${withholdingId}`);
  },
  addWithholdings(data) {
    return Api().post("/withholdings", data);
  },
  updateWithholdingId(withholdingId, data) {
    return Api().put(`/withholdings/${withholdingId}`, data);
  },
  deleteWithholdingId(withholdingId) {
    return Api().delete(`/withholdings/${withholdingId}`);
  },
  sendWithholdingSRI(data) {
    return Api().post(`/sri/signature/withholding`, data);
  },
  sendWithholdingEmail({ data }) {
    return Api().post(`/withholdings/send-email`, data, configFormData);
  },
  updateWithholdingStatus(data) {
    return Api().post(`/status/withholdings`, data);
  },
  withholdingDownload({ id }) {
    return Api().get(`/u/download/withholding?id=${id}`, {
      responseType: "arraybuffer"
    });
  },
  // ════════ Métodos Batch (Optimizados para acciones masivas) ════════
  /**
   * Actualizar estado de múltiples retenciones en un lote
   * @param {Array} withholdingIds - Array de IDs
   * @param {Object} statusData - Datos de estado a actualizar
   */
  updateWithholdingStatusBatch(withholdingIds, statusData) {
    return Api().post(`/status/withholdings`, {
      withholding_ids: withholdingIds,
      ...statusData
    });
  }
};
